import { Scalars } from 'src/generated/base-types';

export function isScalarsId(id: unknown): id is Scalars['ID'] {
  return typeof id === 'string' && id.length > 0;
}
